export default __webpack_public_path__ + "static/media/inseam.5d81cbd0.webp";